export default __webpack_public_path__ + "static/avatar-jaclyn-de-jesus-42cb5fcc17592298da67b1b696735ea4.jpg";